import { Alert, Button, message, Spin, Tooltip } from "antd";
import { EmptyData } from "components/EmptyTable";
import { SelectStudentTheme } from "config/theme/colors";
import instance from "config/_axios";
import { Title } from "pages/styles/style";
import { FC, useEffect, useState } from "react"
import { CgDetailsMore } from "react-icons/cg";
import { NavLink } from "react-router-dom";
import { Card } from "antd";
import { getAllEduSemesters, getAllEduSemesterSubjects } from "services";
import styled from "styled-components";

export type TypeTopics = Array<{
  id: number,
  name: string,
  description: string
}>

const SubjectSelection: FC = (): JSX.Element => {
  const theme = SelectStudentTheme()
  const [subjects, setSubjects] = useState<Array<any>>([])
  const [loading, setLoading] = useState<boolean>(false);
  const [isSave, setIsSave] = useState<boolean>(false);
  const [selectedSubjectId, setSelectedSubjectId] = useState<number | null>();
  // const [isSubjectSelection, setIsSubjectSelection] = useState<number>()

  useEffect(() => {
    (
      async () => {
        try {
          setLoading(true);
          const semester = await getAllEduSemesters('all', 1, 'expand=semestr');
          /*{
            "items": [
                {
                    "id": 325,
                    "name": "2019-2020-1-1",
                    "edu_plan_id": 56,
                    "course_id": 1,
                    "optional_subject_count": 0,
                    "required_subject_count": 0,
                    "semestr_id": 1,
                    "credit": 0,
                    "edu_year_id": 13,
                    "start_date": "2019-09-04 00:00:00",
                    "end_date": "2019-09-04 00:00:00",
                    "is_checked": 1,
                    "order": 1,
                    "status": 0,
                    "created_at": 1652782323,
                    "updated_at": 1667541873,
                    "created_by": 599,
                    "updated_by": 1,
                    "semestr": {
                        "id": 1,
                        "name": "1",
                        "order": 1,
                        "status": 1,
                        "type": 1,
                        "created_at": 0,
                        "updated_at": 0,
                        "created_by": 0,
                        "updated_by": 0
                    }
                },
                {
                    "id": 326,
                    "name": "2019-2020-1-2",
                    "edu_plan_id": 56,
                    "course_id": 1,
                    "optional_subject_count": 0,
                    "required_subject_count": 0,
                    "semestr_id": 2,
                    "credit": 0,
                    "edu_year_id": 13,
                    "start_date": "2020-02-03 00:00:00",
                    "end_date": "2020-06-26 00:00:00",
                    "is_checked": 1,
                    "order": 1,
                    "status": 0,
                    "created_at": 1652782323,
                    "updated_at": 1667541873,
                    "created_by": 599,
                    "updated_by": 1,
                    "semestr": {
                        "id": 2,
                        "name": "2",
                        "order": 1,
                        "status": 1,
                        "type": 2,
                        "created_at": 0,
                        "updated_at": 0,
                        "created_by": 0,
                        "updated_by": 0
                    }
                },
                {
                    "id": 327,
                    "name": "2020-2021-2-3",
                    "edu_plan_id": 56,
                    "course_id": 2,
                    "optional_subject_count": 0,
                    "required_subject_count": 0,
                    "semestr_id": 3,
                    "credit": 0,
                    "edu_year_id": 14,
                    "start_date": "2020-09-04 00:00:00",
                    "end_date": "2020-09-04 00:00:00",
                    "is_checked": 1,
                    "order": 1,
                    "status": 0,
                    "created_at": 1652782323,
                    "updated_at": 1667541873,
                    "created_by": 599,
                    "updated_by": 1,
                    "semestr": {
                        "id": 3,
                        "name": "3",
                        "order": 1,
                        "status": 1,
                        "type": 1,
                        "created_at": 0,
                        "updated_at": 0,
                        "created_by": 0,
                        "updated_by": 0
                    }
                },
                {
                    "id": 328,
                    "name": "2020-2021-2-4",
                    "edu_plan_id": 56,
                    "course_id": 2,
                    "optional_subject_count": 0,
                    "required_subject_count": 0,
                    "semestr_id": 4,
                    "credit": 0,
                    "edu_year_id": 14,
                    "start_date": "2021-02-03 00:00:00",
                    "end_date": "2021-06-26 00:00:00",
                    "is_checked": 1,
                    "order": 1,
                    "status": 0,
                    "created_at": 1652782323,
                    "updated_at": 1667541873,
                    "created_by": 599,
                    "updated_by": 1,
                    "semestr": {
                        "id": 4,
                        "name": "4",
                        "order": 1,
                        "status": 1,
                        "type": 2,
                        "created_at": 0,
                        "updated_at": 0,
                        "created_by": 0,
                        "updated_by": 0
                    }
                },
                {
                    "id": 329,
                    "name": "2021-2022-3-5",
                    "edu_plan_id": 56,
                    "course_id": 3,
                    "optional_subject_count": 0,
                    "required_subject_count": 0,
                    "semestr_id": 5,
                    "credit": 0,
                    "edu_year_id": 15,
                    "start_date": "2021-09-04 00:00:00",
                    "end_date": "2021-09-04 00:00:00",
                    "is_checked": 1,
                    "order": 1,
                    "status": 0,
                    "created_at": 1652782323,
                    "updated_at": 1667541873,
                    "created_by": 599,
                    "updated_by": 1,
                    "semestr": {
                        "id": 5,
                        "name": "5",
                        "order": 1,
                        "status": 1,
                        "type": 1,
                        "created_at": 0,
                        "updated_at": 0,
                        "created_by": 0,
                        "updated_by": 0
                    }
                },
                {
                    "id": 330,
                    "name": "2021-2022-3-6",
                    "edu_plan_id": 56,
                    "course_id": 3,
                    "optional_subject_count": 0,
                    "required_subject_count": 0,
                    "semestr_id": 6,
                    "credit": 0,
                    "edu_year_id": 15,
                    "start_date": "2022-02-03 00:00:00",
                    "end_date": "2022-06-26 00:00:00",
                    "is_checked": 1,
                    "order": 1,
                    "status": 0,
                    "created_at": 1652782323,
                    "updated_at": 1667541873,
                    "created_by": 599,
                    "updated_by": 1,
                    "semestr": {
                        "id": 6,
                        "name": "6",
                        "order": 1,
                        "status": 1,
                        "type": 2,
                        "created_at": 0,
                        "updated_at": 0,
                        "created_by": 0,
                        "updated_by": 0
                    }
                },
                {
                    "id": 331,
                    "name": "2022-2023-4-7",
                    "edu_plan_id": 56,
                    "course_id": 4,
                    "optional_subject_count": 0,
                    "required_subject_count": 0,
                    "semestr_id": 7,
                    "credit": 0,
                    "edu_year_id": 16,
                    "start_date": "2022-09-04 00:00:00",
                    "end_date": "2023-01-31 00:00:00",
                    "is_checked": 1,
                    "order": 1,
                    "status": 1,
                    "created_at": 1652782323,
                    "updated_at": 1667541873,
                    "created_by": 599,
                    "updated_by": 1,
                    "semestr": {
                        "id": 7,
                        "name": "7",
                        "order": 1,
                        "status": 1,
                        "type": 1,
                        "created_at": 0,
                        "updated_at": 0,
                        "created_by": 0,
                        "updated_by": 0
                    }
                },
                {
                    "id": 332,
                    "name": "2022-2023-4-8",
                    "edu_plan_id": 56,
                    "course_id": 4,
                    "optional_subject_count": 0,
                    "required_subject_count": 0,
                    "semestr_id": 8,
                    "credit": 0,
                    "edu_year_id": 16,
                    "start_date": "2023-02-03 00:00:00",
                    "end_date": "2023-06-26 00:00:00",
                    "is_checked": 1,
                    "order": 1,
                    "status": 0,
                    "created_at": 1652782323,
                    "updated_at": 1667541873,
                    "created_by": 599,
                    "updated_by": 1,
                    "semestr": {
                        "id": 8,
                        "name": "8",
                        "order": 1,
                        "status": 1,
                        "type": 2,
                        "created_at": 0,
                        "updated_at": 1657791399,
                        "created_by": 0,
                        "updated_by": 112
                    }
                }
            ],
            "_links": {
                "self": {
                    "href": "https://api-digital.tsul.uz/api/web/uz/edu-semestrs?expand=semestr&per-page=0&page=1"
                },
                "first": {
                    "href": "https://api-digital.tsul.uz/api/web/uz/edu-semestrs?expand=semestr&per-page=0&page=1"
                },
                "last": {
                    "href": "https://api-digital.tsul.uz/api/web/uz/edu-semestrs?expand=semestr&per-page=0&page=1"
                }
            },
            "_meta": {
                "totalCount": 8,
                "pageCount": 1,
                "currentPage": 1,
                "perPage": 0
            }
          }*/
          const active_semester = semester.items.filter((e: any) => e?.status === 1)[0]

          const res = await getAllEduSemesterSubjects('all', 1, `expand=subject,subject.topics,subjectType,selection,sillabus&filter='{"edu_semestr_id":${active_semester?.id}}'`);
          /*{
            "items": [
                {
                    "id": 575,
                    "edu_semestr_id": 331,
                    "subject_id": 286,
                    "subject_type_id": 5,
                    "auditory_time": null,
                    "credit": 6,
                    "all_ball_yuklama": 150,
                    "is_checked": 0,
                    "max_ball": 0,
                    "order": 1,
                    "status": 0,
                    "created_at": 1661950745,
                    "updated_at": 1661950745,
                    "created_by": 7401,
                    "updated_by": 7401,
                    "subject": {
                        "id": 286,
                        "name": "Mahalliy hokimiyat huquqi",
                        "kafedra_id": 15,
                        "semestr_id": 7,
                        "parent_id": 286,
                        "is_deleted": 0,
                        "order": 1,
                        "status": 1,
                        "created_at": 1660303924,
                        "updated_at": 1660303939,
                        "created_by": 591,
                        "updated_by": 591,
                        "topics": [
                            {
                                "id": 1611,
                                "name": "1-mavzu. Mahalliy hokimiyat huquqiga kirish",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "1-mavzu. Mahalliy hokimiyat huquqiga kirish  1. ―Mahalliy hokimiyat huquqi‖ tushunchasi va predmeti.  2. Mahalliy hokimiyat huquqining normalari va institutlari.  3. Mahalliy hokimiyat huquqiy munosabatlari va sub’yektlari.  4. Mahalliy hokimiyat huquqi manbalari.  5. Mahalliy hokimiyat huquqining O‘zbekiston Respublikasi huquq  tizimidagi o‘rni.  6. Mahalliy hokimiyat huquqi fanining predmeti, huquqiy va ijtimoiy  fanlar tizimidagi o‘rni.  7. Mahalliy hokimiyat huquqi o‘quv fani maqsadlari, asosiy vazifalari va  o‘rganish usullari.  Asosiy adabiyot:  Mahalliy boshqaruv: darslik / mualliflar jamoasi / mas’ul muharrir  Sh.Shoymardonov. – Toshkent, 2017. – B. 12-16.  Munisipalnoye pravo: uchebnik dlya bakalavrov / otv. red. V. I. Fadeyev.  — Moskva: Prospekt, 2015. — 336 s. – C.13-61",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660648360,
                                "updated_at": 1660648360,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 1612,
                                "name": "2-mavzu.  Mahalliy hokimiyat  asoslari",
                                "hours": 4,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "2-mavzu. Mahalliy hokimiyatning hududiy va tashkiliy asoslari  1. Mahalliy boshqaruvning nazariy asoslari.  2. Mahalliy hokimiyatning hududiy asoslari va xususiyatlari.  3. Mahalliy hokimiyat organlari tizimi va ularning o‘zaro  munosabatlari.  4. O‘zbekistonda mahalliy davlat hokimiyati islohotlari va axborot  texnologiyalari.  5. Fuqarolarning mahalliy hokimiyatdagi ishtiroki.  6. Xorijiy mamlakatlarda mahalliy boshqaruv modellari.  Asosiy adabiyot:  Mahalliy boshqaruv: darslik / mualliflar jamoasi / mas’ul muharrir  Sh.Shoymardonov. – Toshkent, 2017. – B. 12-16.  Munisipalnoye pravo Rossii: uchebnik / otv. red. S. A. Avakьyan. –  Moskva: Prospekt, 2019. – S. 500-524.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660648419,
                                "updated_at": 1660648419,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 1613,
                                "name": "3-mavzu. Mahalliy hokimiyat organlari huquqiy maqomi",
                                "hours": 4,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "3-mavzu. Mahalliy hokimiyat organlari huquqiy maqomi  1. Hokim va uning o‘rinbosarlari huquqiy maqomi.  2. Mahalliy Kengash va uning deputati huquqiy maqomi.  3. Hokimlik huquqiy maqomi.  4. Hududiy saylov komissiyasi huquqiy maqomi.  5. Mahalliy hokimiyat idoralarida odob-axloq qoidalari.  7  6. Hokim va xalq deputatlari Kengashi faoliyatining tashkiliy va  moddiy-texnik ta’minoti.  Asosiy adabiyot:  Mahalliy boshqaruv: darslik / mualliflar jamoasi / mas’ul muharrir  Sh.Shoymardonov. – Toshkent, 2017. – B. 12-16.  Munisipalnoye pravo Rossii: uchebnik / otv. red. S. A. Avakьyan. –  Moskva: Prospekt, 2019. – S. 500-524",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660648501,
                                "updated_at": 1660649566,
                                "created_by": 591,
                                "updated_by": 591
                            },
                            {
                                "id": 1614,
                                "name": "4-mavzu.  Davlat hokimiyatini  nomarkazlashtirish  shakllari va  sharoitlari",
                                "hours": 3,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "4-mavzu. Davlat hokimiyatini nomarkazlashtirish shakllari va  sharoitlari  1. \"Mahalliy hokimiyat organlarining kompetensiyasi\" tushunchasi va  mazmuni.  2. Davlat hokimiyatini nomarkazlashtirish shakllari va turlari.  3. Mahalliy boshqaruvning iqtisodiy asoslari va fiskal  nomarkazlashtirish.  4. Davlat hokimiyati va boshqaruvi organlarining vakolatlarini aniqlash  va chegaralash.  5. O‘zbekistonda hududiy ishtirok shakllari.  Asosiy adabiyot:  Jo‘rayev R.T. O‘zbekistonda umumdavlat va hududiy manfaatlar  mutanosibligiga erishishning siѐsiy jihatlari. – T.: ―Akademiya‖, 2009. – 71-  98.  Mahalliy boshqaruv: darslik / mualliflar jamoasi / mas’ul muharrir  Sh.Shoymardonov. – Toshkent, 2017. – B. 12-16.  Munisipalnoye pravo Rossii: u",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660648553,
                                "updated_at": 1660648620,
                                "created_by": 591,
                                "updated_by": 591
                            },
                            {
                                "id": 1615,
                                "name": "5-mavzu.  Mahalliy hokimiyat  organlari faoliyati  ustidan davlat  nazoratining  chegaralari",
                                "hours": 4,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "5-mavzu. Mahalliy hokimiyat organlari faoliyati ustidan davlat  nazoratining chegaralari  1. Mahalliy hokimiyat organlari faoliyatining qonuniyligi ustidan  davlat nazorati.  2. Mahalliy hokimiyat organlari faoliyati samaradorligini baholash.  3. Mahalliy hokimiyat organlarida korrupsiyaga qarshi kurash.  4. Mahalliy hokimiyat organlari javobgarligi.  5. Mahalliy hokimiyat organlari hatti-harakatlari ustidan shikoyat  qilish.  Asosiy adabiyot:  Jo‘rayev R.T. O‘zbekistonda umumdavlat va hududiy manfaatlar  mutanosibligiga erishishning siѐsiy jihatlari. – T.: ―Akademiya‖, 2009. – 84-  98.  Munisipalnoye pravo Rossii: uchebnik / otv. red. S. A. Avakьyan. –  Moskva: Prospekt, 2019. – S. 500-524.  Mahalliy boshqaruv: darslik / mualliflar jamoasi / mas’ul muharrir  Sh.Shoymardonov. – Toshkent, 2017. – B. 12-16.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660648699,
                                "updated_at": 1660648699,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 1616,
                                "name": "6-mavzu.  Mahalliy hokimiyat  organlarining  kompetensiyasi",
                                "hours": 4,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "6-mavzu. Mahalliy hokimiyat organlarining kompetensiyasi  1. Mahalliy hokimiyat organlarining iqtisodiy rivojlanish va kambag‘allikni  qisqartirish sohasidagi vakolatlari  2. Mahalliy hokimiyat organlarining ijtimoiy sohani boshqarishdagi  vakolatlari  3. Mahalliy davlat hokimiyati organlarining mahalla va oilani qo‘llabquvvatlash sohasidagi vakolatlari.  4. Mahalliy hokimiyat organlarining ekologiya sohasidagi vakolatlari.  5. Mahalliy hokimiyat organlarining fuqarolar xavfsizligini, qonuniylik va  huquqiy tartibotni ta’minlash sohasidagi vakolatlari.  Asosiy adabiyot:  Mahalliy boshqaruv: darslik / mualliflar jamoasi / mas’ul muharrir  Sh.Shoymardonov. – Toshkent, 2017. – B. 12-16.  Munisipalnoye pravo Rossii: uchebnik / otv. red. S. A. Avakьyan. –  Moskva: Prospekt, 2019. – S. 500-524.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660648783,
                                "updated_at": 1660648783,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 1617,
                                "name": "7-mavzu.  Xalq deputatlari  Kengashlari  faoliyatining tashkiliy  shakllari va usullari",
                                "hours": 4,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "7-mavzu. Xalq deputatlari Kengashlari faoliyatining tashkiliy  shakllari va usullari  1. Xalq deputatlari Kengashlari sessiyalarini tashkil etish va o‘tkazish  2. Xalq deputatlari Kengashlari muvaqqat va doimiy komissiyalari  3. Xalq deputatlari Kengashlaridagi partiya guruhlari  4. Deputatning saylov okrugidagi faoliyati  5. Xalq deputatlari Kengashi qarorlarini qabul qilish  6. Xalq deputatlari Kengashi ishini rejalashtirish.  Asosiy adabiyot:  Mahalliy boshqaruv: darslik / mualliflar jamoasi / mas’ul muharrir  Sh.Shoymardonov. – Toshkent, 2017. – B. 12-16.  Ismailova G.S., Radjabova M.A., Yo‘ldoshev A.E. va Mahmudov A.A. Xalq  deputatlari mahalliy Kengashlari faoliyatini tashkil etish va amalga  oshirish: Amaliy qo‘llanma. – Toshkent: Spectrum Media Group. 2015. – B. 5-150.  Yo‘ldoshev A., Hasanova M.B., Yelshov M.L. Xalq deputatlarining  mahalliy Kengashlaridagi partiya guruhlari (uslubiy qo‘llanma). – Toshkent,  2019. – B. 10-57.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660648884,
                                "updated_at": 1660648884,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 1618,
                                "name": "8-mavzu. Xalq deputatlari Kengashlarining nazorat faoliyati",
                                "hours": 4,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "8-mavzu. Xalq deputatlari Kengashlarining nazorat faoliyati  1. Xalq deputatlari Kengashlari nazoratining mazmuni.  2. Qonun hujjatlari ijrosi ustidan nazoratni tashkil qilish.  3. Deputat so‘rovini yuborish tartibi.  4. Mansabdor shaxslarning xalq deputatlari Kengashlari nazorati sohasidagi  javobgarligi.  Asosiy adabiyot:",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660648950,
                                "updated_at": 1660648950,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 1619,
                                "name": "9-mavzu. Hokim va hokimlik faoliyatining shakllari va usullari ",
                                "hours": 4,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "9-mavzu. Hokim va hokimlik faoliyatining shakllari va usullari  1. Hokimning o‘z vakolatlarini yakkaboshchilik asosida amalga oshirishi.  2. Hokimliklar huzuridagi komissiyalar va kengashlar.  3. Hududlarni ijtimoiy-iqtisodiy rivojlantirish sektorlari.  4. Hokim qarorlarini qabul qili.  5. Hokim va hokimliklar faoliyatining usullari.  Asosiy adabiyot:  Mahalliy boshqaruv: dasrlik / mualliflar jamoasi / mas’ul muharrir  Sh.Shoymardonov. – Toshkent, 2017. – B. 190-241.  Azizov X.T., Xayitov X.S. va Yo‘ldoshev A.E. Mahalliy davlat hokimiyati  organlari qarorlarini tayѐrlashning tashkiliy-huquqiy asoslari. – T:  ―Tafakkur qanoti‖, 2019. – B. 6-95.  Sistema munisipalnogo upravleniya: uchebnik / kollektiv avtorov; pod  red. V.B. Zotova; ruk. avt. kol. R.V. Babun. — 6-ye izd., ispr. i dop. — Moskva:  KNORUS, 2018. – S. 16-54.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660649065,
                                "updated_at": 1660649065,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 1620,
                                "name": "10-mavzu. Mahalliy hokimiyat organlarida jismoniy va yuridik shaxslar  murojaatlari bilan ishlash",
                                "hours": 4,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "10-mavzu. Mahalliy hokimiyat organlarida jismoniy va yuridik shaxslar  murojaatlari bilan ishlash  1. Jismoniy va yuridik shaxslarning mahalliy hokimiyat organlariga  murojaat qilish huquqi  2. Hokimliklarda murojaatlarni ko‘rib chiqish tartibi  3. Mahalliy Kengashlar va deputatlar tomonidan murojaatlarni ko‘rib  chiqish xususiyatlari  4. Murojaatlar ko‘rib chiqilishi monitoringi va tahlili  5. Murojaatlar bilan ishlashda Xalq qabulxonalari  6. Murojaatlar to‘g‘risidagi qonun hujjatlarini buzganlik uchun  javobgarlik  Asosiy adabiyot:  Munisipalnoye pravo Rossii: uchebnik / otv. red. S. A. Avakьyan. –  Moskva: Prospekt, 2019. – S. 500-524.  Sistema munisipalnogo upravleniya: uchebnik / kollektiv avtorov; pod  red. V.B. Zotova; ruk. avt. kol. R.V. Babun. — 6-ye izd., ispr. i dop. — Moskva:  KNORUS, 2018. – S. 16-54.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660649112,
                                "updated_at": 1660649112,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 1631,
                                "name": "1-mavzu. Mahalliy hokimiyat huquqiga kirish",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "1-mavzu. Mahalliy hokimiyat huquqiga kirish  1. ―Mahalliy hokimiyat huquqi‖ tushunchasi va predmeti.  2. Mahalliy hokimiyat huquqining normalari va institutlari.  3. Mahalliy hokimiyat huquqiy munosabatlari va sub’yektlari.  4. Mahalliy hokimiyat huquqi manbalari.  5. Mahalliy hokimiyat huquqining O‘zbekiston Respublikasi huquq  tizimidagi o‘rni.  6. Mahalliy hokimiyat huquqi fanining predmeti, huquqiy va ijtimoiy  fanlar tizimidagi o‘rni.  7. Mahalliy hokimiyat huquqi o‘quv fani maqsadlari, asosiy vazifalari va  o‘rganish usullari.  Asosiy adabiyot:  Mahalliy boshqaruv: darslik / mualliflar jamoasi / mas’ul muharrir  Sh.Shoymardonov. – Toshkent, 2017. – B. 12-16.  Munisipalnoye pravo: uchebnik dlya bakalavrov / otv. red. V. I. Fadeyev.  — Moskva: Prospekt, 2015. — 336 s. – C.13-61",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660649440,
                                "updated_at": 1660649440,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 1632,
                                "name": "2-mavzu.  Mahalliy hokimiyat  asoslari",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "2-mavzu. Mahalliy hokimiyatning hududiy va tashkiliy asoslari  1. Mahalliy boshqaruvning nazariy asoslari.  2. Mahalliy hokimiyatning hududiy asoslari va xususiyatlari.  3. Mahalliy hokimiyat organlari tizimi va ularning o‘zaro  munosabatlari.  4. O‘zbekistonda mahalliy davlat hokimiyati islohotlari va axborot  texnologiyalari.  5. Fuqarolarning mahalliy hokimiyatdagi ishtiroki.  6. Xorijiy mamlakatlarda mahalliy boshqaruv modellari.  Asosiy adabiyot:  Mahalliy boshqaruv: darslik / mualliflar jamoasi / mas’ul muharrir  Sh.Shoymardonov. – Toshkent, 2017. – B. 12-16.  Munisipalnoye pravo Rossii: uchebnik / otv. red. S. A. Avakьyan. –  Moskva: Prospekt, 2019. – S. 500-524.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660649464,
                                "updated_at": 1660649464,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 1633,
                                "name": "Тема №3.  Правовой статус органов местной власти ",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660649498,
                                "updated_at": 1661591892,
                                "created_by": 591,
                                "updated_by": 591
                            },
                            {
                                "id": 1634,
                                "name": "4-mavzu.  Davlat hokimiyatini  nomarkazlashtirish  shakllari va  sharoitlari",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "4-mavzu. Davlat hokimiyatini nomarkazlashtirish shakllari va  sharoitlari  1. \"Mahalliy hokimiyat organlarining kompetensiyasi\" tushunchasi va  mazmuni.  2. Davlat hokimiyatini nomarkazlashtirish shakllari va turlari.  3. Mahalliy boshqaruvning iqtisodiy asoslari va fiskal  nomarkazlashtirish.  4. Davlat hokimiyati va boshqaruvi organlarining vakolatlarini aniqlash  va chegaralash.  5. O‘zbekistonda hududiy ishtirok shakllari.  Asosiy adabiyot:  Jo‘rayev R.T. O‘zbekistonda umumdavlat va hududiy manfaatlar  mutanosibligiga erishishning siѐsiy jihatlari. – T.: ―Akademiya‖, 2009. – 71-  98.  Mahalliy boshqaruv: darslik / mualliflar jamoasi / mas’ul muharrir  Sh.Shoymardonov. – Toshkent, 2017. – B. 12-16.  Munisipalnoye pravo Rossii: u",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660649535,
                                "updated_at": 1660649535,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 1635,
                                "name": "5-mavzu. Mahalliy hokimiyat organlari faoliyati ustidan davlat  nazoratining chegaralari",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "5-mavzu. Mahalliy hokimiyat organlari faoliyati ustidan davlat  nazoratining chegaralari  1. Mahalliy hokimiyat organlari faoliyatining qonuniyligi ustidan  davlat nazorati.  2. Mahalliy hokimiyat organlari faoliyati samaradorligini baholash.  3. Mahalliy hokimiyat organlarida korrupsiyaga qarshi kurash.  4. Mahalliy hokimiyat organlari javobgarligi.  5. Mahalliy hokimiyat organlari hatti-harakatlari ustidan shikoyat  qilish.  Asosiy adabiyot:  Jo‘rayev R.T. O‘zbekistonda umumdavlat va hududiy manfaatlar  mutanosibligiga erishishning siѐsiy jihatlari. – T.: ―Akademiya‖, 2009. – 84-  98.  Munisipalnoye pravo Rossii: uchebnik / otv. red. S. A. Avakьyan. –  Moskva: Prospekt, 2019. – S. 500-524.  Mahalliy boshqaruv: darslik / mualliflar jamoasi / mas’ul muharrir  Sh.Shoymardonov. – Toshkent, 2017. – B. 12-16.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660649598,
                                "updated_at": 1660649598,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 1639,
                                "name": "6-mavzu. Mahalliy hokimiyat organlarining kompetensiyasi",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "6-mavzu. Mahalliy hokimiyat organlarining kompetensiyasi  1. Mahalliy hokimiyat organlarining iqtisodiy rivojlanish va kambag‘allikni  qisqartirish sohasidagi vakolatlari  2. Mahalliy hokimiyat organlarining ijtimoiy sohani boshqarishdagi  vakolatlari  3. Mahalliy davlat hokimiyati organlarining mahalla va oilani qo‘llabquvvatlash sohasidagi vakolatlari.  4. Mahalliy hokimiyat organlarining ekologiya sohasidagi vakolatlari.  5. Mahalliy hokimiyat organlarining fuqarolar xavfsizligini, qonuniylik va  huquqiy tartibotni ta’minlash sohasidagi vakolatlari.  Asosiy adabiyot:  Mahalliy boshqaruv: darslik / mualliflar jamoasi / mas’ul muharrir  Sh.Shoymardonov. – Toshkent, 2017. – B. 12-16.  Munisipalnoye pravo Rossii: uchebnik / otv. red. S. A. Avakьyan. –  Moskva: Prospekt, 2019. – S. 500-524.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660649637,
                                "updated_at": 1660649637,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 1642,
                                "name": "7-mavzu. Xalq deputatlari Kengashlari faoliyatining tashkiliy  shakllari va usullari ",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "7-mavzu. Xalq deputatlari Kengashlari faoliyatining tashkiliy  shakllari va usullari  1. Xalq deputatlari Kengashlari sessiyalarini tashkil etish va o‘tkazish  2. Xalq deputatlari Kengashlari muvaqqat va doimiy komissiyalari  3. Xalq deputatlari Kengashlaridagi partiya guruhlari  4. Deputatning saylov okrugidagi faoliyati  5. Xalq deputatlari Kengashi qarorlarini qabul qilish  6. Xalq deputatlari Kengashi ishini rejalashtirish.  Asosiy adabiyot:  Mahalliy boshqaruv: darslik / mualliflar jamoasi / mas’ul muharrir  Sh.Shoymardonov. – Toshkent, 2017. – B. 12-16.  Ismailova G.S., Radjabova M.A., Yo‘ldoshev A.E. va Mahmudov A.A. Xalq  deputatlari mahalliy Kengashlari faoliyatini tashkil etish va amalga  oshirish: Amaliy qo‘llanma. – Toshkent: Spectrum Media Group. 2015. – B. 5-150.  Yo‘ldoshev A., Hasanova M.B., Yelshov M.L. Xalq deputatlarining  mahalliy Kengashlaridagi partiya guruhlari (uslubiy qo‘llanma). – Toshkent,  2019. – B. 10-57.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660649664,
                                "updated_at": 1660649664,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 1645,
                                "name": "8-mavzu. Xalq deputatlari Kengashlarining nazorat faoliyati",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "8-mavzu. Xalq deputatlari Kengashlarining nazorat faoliyati  1. Xalq deputatlari Kengashlari nazoratining mazmuni.  2. Qonun hujjatlari ijrosi ustidan nazoratni tashkil qilish.  3. Deputat so‘rovini yuborish tartibi.  4. Mansabdor shaxslarning xalq deputatlari Kengashlari nazorati sohasidagi  javobgarligi.  Asosiy adabiyot:",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660649699,
                                "updated_at": 1660649699,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 1648,
                                "name": "9-mavzu. Hokim va hokimlik faoliyatining shakllari va usullari",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "9-mavzu. Hokim va hokimlik faoliyatining shakllari va usullari  1. Hokimning o‘z vakolatlarini yakkaboshchilik asosida amalga oshirishi.  2. Hokimliklar huzuridagi komissiyalar va kengashlar.  3. Hududlarni ijtimoiy-iqtisodiy rivojlantirish sektorlari.  4. Hokim qarorlarini qabul qili.  5. Hokim va hokimliklar faoliyatining usullari.  Asosiy adabiyot:  Mahalliy boshqaruv: dasrlik / mualliflar jamoasi / mas’ul muharrir  Sh.Shoymardonov. – Toshkent, 2017. – B. 190-241.  Azizov X.T., Xayitov X.S. va Yo‘ldoshev A.E. Mahalliy davlat hokimiyati  organlari qarorlarini tayѐrlashning tashkiliy-huquqiy asoslari. – T:  ―Tafakkur qanoti‖, 2019. – B. 6-95.  Sistema munisipalnogo upravleniya: uchebnik / kollektiv avtorov; pod  red. V.B. Zotova; ruk. avt. kol. R.V. Babun. — 6-ye izd., ispr. i dop. — Moskva:  KNORUS, 2018. – S. 16-54.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660649736,
                                "updated_at": 1660649736,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 1650,
                                "name": "10-mavzu. Mahalliy hokimiyat organlarida jismoniy va yuridik shaxslar  murojaatlari bilan ishlash",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "10-mavzu. Mahalliy hokimiyat organlarida jismoniy va yuridik shaxslar  murojaatlari bilan ishlash  1. Jismoniy va yuridik shaxslarning mahalliy hokimiyat organlariga  murojaat qilish huquqi  2. Hokimliklarda murojaatlarni ko‘rib chiqish tartibi  3. Mahalliy Kengashlar va deputatlar tomonidan murojaatlarni ko‘rib  chiqish xususiyatlari  4. Murojaatlar ko‘rib chiqilishi monitoringi va tahlili  5. Murojaatlar bilan ishlashda Xalq qabulxonalari  6. Murojaatlar to‘g‘risidagi qonun hujjatlarini buzganlik uchun  javobgarlik  Asosiy adabiyot:  Munisipalnoye pravo Rossii: uchebnik / otv. red. S. A. Avakьyan. –  Moskva: Prospekt, 2019. – S. 500-524.  Sistema munisipalnogo upravleniya: uchebnik / kollektiv avtorov; pod  red. V.B. Zotova; ruk. avt. kol. R.V. Babun. — 6-ye izd., ispr. i dop. — Moskva:  KNORUS, 2018. – S. 16-54.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1660649770,
                                "updated_at": 1660649770,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 2945,
                                "name": "Тема №1. Введение в право местной власти",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661591560,
                                "updated_at": 1661592197,
                                "created_by": 591,
                                "updated_by": 591
                            },
                            {
                                "id": 2947,
                                "name": "Теоретические, территориальные и оранизационные основы местной власти",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661591584,
                                "updated_at": 1661591584,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 2952,
                                "name": "Тема №4.  Формы и условия децентрализации государственной власти ",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661591962,
                                "updated_at": 1661591962,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 2953,
                                "name": "Тема №5.  Пределы государственного контроля над деятельностью органов местной власти ",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661591997,
                                "updated_at": 1661591997,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 2954,
                                "name": "Тема №6.  Компетенция органов местной власти",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661592024,
                                "updated_at": 1661592024,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 2955,
                                "name": "Тема №7.  Организационные формы и способы деятельности Кенгашей народных депутатов",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661592045,
                                "updated_at": 1661592045,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 2956,
                                "name": "Тема №8.  Контрольная деятельность Кенгашей народных депутатов",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661592068,
                                "updated_at": 1661592068,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 2957,
                                "name": "Тема №9.  Организационные формы и способы деятельности хокима и хокимиятов ",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661592089,
                                "updated_at": 1661592089,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 2958,
                                "name": "Тема №10. Работа органов местной власти с обращениями физических и юридических лиц",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661592141,
                                "updated_at": 1661592141,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3019,
                                "name": "Введение в право местной власти",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661597801,
                                "updated_at": 1661597801,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3020,
                                "name": "Территориальные и организационные основы местной власти",
                                "hours": 4,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661597817,
                                "updated_at": 1661597817,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3021,
                                "name": "Правовой статус органов местной власти ",
                                "hours": 4,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661597833,
                                "updated_at": 1661597833,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3022,
                                "name": "Формы и условия децентрализации государственной власти ",
                                "hours": 3,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661597853,
                                "updated_at": 1661597853,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3023,
                                "name": "Пределы государственного контроля деятельности органов местной власти ",
                                "hours": 4,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661597871,
                                "updated_at": 1661597871,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3024,
                                "name": "Компетенция органов местной власти",
                                "hours": 4,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661597890,
                                "updated_at": 1661597890,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3025,
                                "name": "Организационные формы и способы деятельности Кенгашей народных депутатов ",
                                "hours": 4,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661597908,
                                "updated_at": 1661597908,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3026,
                                "name": "Контрольная деятельность Кенгашей народных депутатов",
                                "hours": 4,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661597924,
                                "updated_at": 1661597924,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3027,
                                "name": "Организационные формы и способы деятельности хокима и хокимиятов ",
                                "hours": 4,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661597938,
                                "updated_at": 1661597938,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3028,
                                "name": "Работа с обращениями физических и юридических лиц в органах местной власти",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661597955,
                                "updated_at": 1661597955,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3029,
                                "name": "3-mavzu. Mahalliy hokimiyat organlari huquqiy maqomi",
                                "hours": 2,
                                "subject_id": 286,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661598041,
                                "updated_at": 1661598041,
                                "created_by": 591,
                                "updated_by": 0
                            }
                        ]
                    },
                    "subjectType": {
                        "id": 5,
                        "name": "Majburiy",
                        "order": 1,
                        "status": 1,
                        "created_at": 1643784471,
                        "updated_at": 1643784471,
                        "created_by": 2,
                        "updated_by": 0
                    },
                    "selection": null
                },
                {
                    "id": 598,
                    "edu_semestr_id": 331,
                    "subject_id": 209,
                    "subject_type_id": 6,
                    "auditory_time": null,
                    "credit": 6,
                    "all_ball_yuklama": 150,
                    "is_checked": 0,
                    "max_ball": 100,
                    "order": 1,
                    "status": 0,
                    "created_at": 1662119853,
                    "updated_at": 1662711283,
                    "created_by": 7401,
                    "updated_by": 7401,
                    "subject": {
                        "id": 209,
                        "name": "Xalqaro xususiy huquq",
                        "kafedra_id": 20,
                        "semestr_id": 5,
                        "parent_id": null,
                        "is_deleted": 0,
                        "order": 1,
                        "status": 1,
                        "created_at": 1655183474,
                        "updated_at": 1655183540,
                        "created_by": 601,
                        "updated_by": 601,
                        "topics": [
                            {
                                "id": 2960,
                                "name": "Халқаро хусусий ҳуқуқ моҳияти, тамойиллари, манбалари ва субъектлари",
                                "hours": 2,
                                "subject_id": 209,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади. ",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661594793,
                                "updated_at": 1661865356,
                                "created_by": 601,
                                "updated_by": 601
                            },
                            {
                                "id": 3030,
                                "name": "Ашёвий ва номулкий ҳуқуқларни коллизион масалалари",
                                "hours": 2,
                                "subject_id": 209,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "•\tхалқаро хусусий ҳуқуқнинг асосий масалалари юзасидан чуқур билим олишни таъминлаш; •\tталабаларда халқаро хусусий ҳуқуқ нормаларини қўллаш бўйича чуқур амалий ва назарий билим ва кўникмаларни шакллантириш; •\tўқув дастури фани билан тартибга солинадиган муносабатлар ва уларнинг табиати, чет эл элементи билан мураккаблашган хусусий-ҳуқуқий муносабатларни тартибга солувчи миллий ва халқаро ҳуқуқий нормалар тўғрисида етарли билимга эга бўлиш; •\t амалдаги қонунларни шарҳлаш ва қўллай олиш учун зарур кўникма ва малакани шакллантириш; •\tталабаларга халқаро хусусий ҳуқуқ фанининг асосий тушунча, тамойиллари ва категориялари тўғрисида изчил назарий билим бериш; •\tхалқаро хусусий ҳуқуқ муносабатларни тартибга солувчи коллизион ва моддий нормаларни тўғри қўллай олишни ўргатиш; •\tтурли халқаро хусусий ҳуқуқий институтларни танқидий таҳлил этиш ва баҳолаш учун зарурий билимлар асосини таъминлаш; •\tмантиқий ва танқидий фикрлаш кўникмаларини шакллантириш; •\tхалқаро хусусий ҳуқуқ назарияси ва амалиётига дахлдор маълумотлар билан мустақил ишлаш кўникмасини шакллантириш; •\tқонунчиликдаги коллизион нормаларни амалиётда қўллаш кўникмаларини шакллантириш; •\tташқииқтисодий битимларни тўғри расмийлаштиришни ўргатиш; •\tталабанинг мустақил таълим олишига кўмаклашиш; •\tоғзаки нутқ қобилияти ва риторика; •\tўқув-машғулот суд (Moot Court) мусобақаларида иштирок этиш; •\tқонун ҳужжатлари билан ишлаш (халқаро ва миллий), халқаро тижорат арбитражи ва арбитраж амалиётига оид илмий адабиётлар ва таҳлилий материалларни тушуниш. Модул охирида талабалар қуйидагилар бўйича билимга эга бўладилар:  •\tХалқаро хусусий ҳуқуқий тартибга солишнинг Ўзбекистонда, хорижий давлатларда ҳамда ҳалқаро миқёсидаги асослари, хусусан халқаро ҳуқуқий ҳужжатлар, шунингдек халқаро хусусий ҳуқуққа оид миллий қонунчилик; •\tхалқаро хусусий ҳуқуқнинг тартибга солиш усуллари, унинг тартибга солиш соҳалари билан боғлиқ асосий масалалар; •\tчет эл элементи билан мураккаблашган фуқаролик-ҳуқуқий муносабатлар, халқаро савдо, меҳнат, оила, мажбурият ва бошқа хусусий ҳуқуқга оид масалаларни коллизион тартибга солиш, халқаро тижорат арбитраж, унинг турлари, қарорлари ва уни ижрога қаратиш. Қуйидаги кўникмаларга эга бўладилар: “Халқаро хусусий ҳуқуқ” фанини ўзлаштириш жараёни амалга оширилгандан сўнг бакалавр: •\tчет эл элементи билан мураккаблашган фуқаролик-ҳуқуқий муносабатларни тартибга солувчи коллизион нормалар ва моддий ҳуқуқий нормаларни мустақил тарзда танқидий таҳлил этиш ва амалда қўллай олиш назарий билимларга эга бўлиши; •\tхалқаро хусусий ҳуқуқда чет эл ҳуқуқи нормалари мазмунини аниқлаш, қарши томон ва учинчи мамлакат ҳуқуқига ҳавола этиш, ҳуқуқни ўзаролик асосида қўллаш, оммавий тартиб тўғрисидаги изоҳ, ҳуқуқий тизимлари кўп бўлган мамлакатнинг ҳуқуқини қўллаш ва реторсиялар тўғрисида чуқур билимини намойиш этиш амалий кўникмаларни  эгаллаши; •\tчет эл элементи билан мураккаблашган муносабатларни тартибга солувчи миллий ҳамда халқаро ҳуқуқий хужжатларни тўлиқ ўзлаштириши, халқаро хусусий ҳуқуқда унификация ва кодификациялаш усуллари тўғрисида малакаларни эгаллаши лозим. Қуйидаги қобилиятларни эгаллайдилар: •\tАхборот билан ишлаш (турли манбалардан илмий ва касбий вазифаларни бажариш учун зарур бўлган маълумотларни излаш, баҳолаш ва фойдаланиш, шу билан бирга тизимли ёндошув); •\tхалқаро ҳуқуқий муҳитда ишлаш, кундалик ҳуқуқий фаолиятда халқаро хусусий ҳуқуқни қўллаш; •\tмуаммонинг энг самарали ва мақбул ҳуқуқий ечимини топиш, муаммога ҳамда мижозга йўналтирилган ёндашувларни ривожлантириш; •\tюридик, қиёсий ва бошқа ўзига хос методдан фойдаланган ҳолда, тегишли ҳуқуққа оид маълумотни излаш, таҳлил қилиш ва ишлаш; •\tпрофессионал соҳада юзага келадиган ҳуқуқий муаммолар ва вазиятларни тавсифлай билиш.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661598227,
                                "updated_at": 1661865411,
                                "created_by": 601,
                                "updated_by": 601
                            },
                            {
                                "id": 3094,
                                "name": "Битимларни коллизион масалалари. Электрон шартномалар ва Smart контрактлар",
                                "hours": 1,
                                "subject_id": 209,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "•\tхалқаро хусусий ҳуқуқнинг асосий масалалари юзасидан чуқур билим олишни таъминлаш; •\tталабаларда халқаро хусусий ҳуқуқ нормаларини қўллаш бўйича чуқур амалий ва назарий билим ва кўникмаларни шакллантириш; •\tўқув дастури фани билан тартибга солинадиган муносабатлар ва уларнинг табиати, чет эл элементи билан мураккаблашган хусусий-ҳуқуқий муносабатларни тартибга солувчи миллий ва халқаро ҳуқуқий нормалар тўғрисида етарли билимга эга бўлиш; •\t амалдаги қонунларни шарҳлаш ва қўллай олиш учун зарур кўникма ва малакани шакллантириш; •\tталабаларга халқаро хусусий ҳуқуқ фанининг асосий тушунча, тамойиллари ва категориялари тўғрисида изчил назарий билим бериш; •\tхалқаро хусусий ҳуқуқ муносабатларни тартибга солувчи коллизион ва моддий нормаларни тўғри қўллай олишни ўргатиш; •\tтурли халқаро хусусий ҳуқуқий институтларни танқидий таҳлил этиш ва баҳолаш учун зарурий билимлар асосини таъминлаш; •\tмантиқий ва танқидий фикрлаш кўникмаларини шакллантириш; •\tхалқаро хусусий ҳуқуқ назарияси ва амалиётига дахлдор маълумотлар билан мустақил ишлаш кўникмасини шакллантириш; •\tқонунчиликдаги коллизион нормаларни амалиётда қўллаш кўникмаларини шакллантириш; •\tташқииқтисодий битимларни тўғри расмийлаштиришни ўргатиш; •\tталабанинг мустақил таълим олишига кўмаклашиш; •\tоғзаки нутқ қобилияти ва риторика; •\tўқув-машғулот суд (Moot Court) мусобақаларида иштирок этиш; •\tқонун ҳужжатлари билан ишлаш (халқаро ва миллий), халқаро тижорат арбитражи ва арбитраж амалиётига оид илмий адабиётлар ва таҳлилий материалларни тушуниш. Модул охирида талабалар қуйидагилар бўйича билимга эга бўладилар:  •\tХалқаро хусусий ҳуқуқий тартибга солишнинг Ўзбекистонда, хорижий давлатларда ҳамда ҳалқаро миқёсидаги асослари, хусусан халқаро ҳуқуқий ҳужжатлар, шунингдек халқаро хусусий ҳуқуққа оид миллий қонунчилик; •\tхалқаро хусусий ҳуқуқнинг тартибга солиш усуллари, унинг тартибга солиш соҳалари билан боғлиқ асосий масалалар; •\tчет эл элементи билан мураккаблашган фуқаролик-ҳуқуқий муносабатлар, халқаро савдо, меҳнат, оила, мажбурият ва бошқа хусусий ҳуқуқга оид масалаларни коллизион тартибга солиш, халқаро тижорат арбитраж, унинг турлари, қарорлари ва уни ижрога қаратиш. Қуйидаги кўникмаларга эга бўладилар: “Халқаро хусусий ҳуқуқ” фанини ўзлаштириш жараёни амалга оширилгандан сўнг бакалавр: •\tчет эл элементи билан мураккаблашган фуқаролик-ҳуқуқий муносабатларни тартибга солувчи коллизион нормалар ва моддий ҳуқуқий нормаларни мустақил тарзда танқидий таҳлил этиш ва амалда қўллай олиш назарий билимларга эга бўлиши; •\tхалқаро хусусий ҳуқуқда чет эл ҳуқуқи нормалари мазмунини аниқлаш, қарши томон ва учинчи мамлакат ҳуқуқига ҳавола этиш, ҳуқуқни ўзаролик асосида қўллаш, оммавий тартиб тўғрисидаги изоҳ, ҳуқуқий тизимлари кўп бўлган мамлакатнинг ҳуқуқини қўллаш ва реторсиялар тўғрисида чуқур билимини намойиш этиш амалий кўникмаларни  эгаллаши; •\tчет эл элементи билан мураккаблашган муносабатларни тартибга солувчи миллий ҳамда халқаро ҳуқуқий хужжатларни тўлиқ ўзлаштириши, халқаро хусусий ҳуқуқда унификация ва кодификациялаш усуллари тўғрисида малакаларни эгаллаши лозим. Қуйидаги қобилиятларни эгаллайдилар: •\tАхборот билан ишлаш (турли манбалардан илмий ва касбий вазифаларни бажариш учун зарур бўлган маълумотларни излаш, баҳолаш ва фойдаланиш, шу билан бирга тизимли ёндошув); •\tхалқаро ҳуқуқий муҳитда ишлаш, кундалик ҳуқуқий фаолиятда халқаро хусусий ҳуқуқни қўллаш; •\tмуаммонинг энг самарали ва мақбул ҳуқуқий ечимини топиш, муаммога ҳамда мижозга йўналтирилган ёндашувларни ривожлантириш; •\tюридик, қиёсий ва бошқа ўзига хос методдан фойдаланган ҳолда, тегишли ҳуқуққа оид маълумотни излаш, таҳлил қилиш ва ишлаш; •\tпрофессионал соҳада юзага келадиган ҳуқуқий муаммолар ва вазиятларни тавсифлай билиш.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661600528,
                                "updated_at": 1661865457,
                                "created_by": 601,
                                "updated_by": 601
                            },
                            {
                                "id": 3117,
                                "name": "Халқаро кредит ва хисоб-китоб муносабатларини тартибга солиниши",
                                "hours": 2,
                                "subject_id": 209,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади. ",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661600903,
                                "updated_at": 1661865697,
                                "created_by": 601,
                                "updated_by": 601
                            },
                            {
                                "id": 3138,
                                "name": "Халқаро ташишларни тартибга солиниши",
                                "hours": 2,
                                "subject_id": 209,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади. ",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661601244,
                                "updated_at": 1661865726,
                                "created_by": 601,
                                "updated_by": 601
                            },
                            {
                                "id": 3159,
                                "name": "Деликтларнинг коллизон масалалари",
                                "hours": 1,
                                "subject_id": 209,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади. ",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661601752,
                                "updated_at": 1661865760,
                                "created_by": 601,
                                "updated_by": 601
                            },
                            {
                                "id": 3164,
                                "name": "Оила ва ворислик муносабатларини коллизион масалалари",
                                "hours": 2,
                                "subject_id": 209,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади. ",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661602083,
                                "updated_at": 1661865798,
                                "created_by": 601,
                                "updated_by": 601
                            },
                            {
                                "id": 3165,
                                "name": "Интеллектуал мулкни химоя қилишнинг коллизион масалалари",
                                "hours": 2,
                                "subject_id": 209,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади. ",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661602569,
                                "updated_at": 1661865835,
                                "created_by": 601,
                                "updated_by": 601
                            },
                            {
                                "id": 3209,
                                "name": "Кибер ҳуқуқни коллизон масалалари",
                                "hours": 2,
                                "subject_id": 209,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади. ",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605596,
                                "updated_at": 1661748799,
                                "created_by": 601,
                                "updated_by": 601
                            },
                            {
                                "id": 3210,
                                "name": "Халқаро хусусий ҳуқуқда юрисдикция ва низоларни хал этиш. Халқаро артбитраж",
                                "hours": 2,
                                "subject_id": 209,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади. ",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605864,
                                "updated_at": 1661865891,
                                "created_by": 601,
                                "updated_by": 601
                            },
                            {
                                "id": 4615,
                                "name": "Сущность, принципы, источники и субъекты международного частного права.",
                                "hours": 6,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "Курс «Международное частное право» рассматривает роль гражданско-правовых отношений с участием иностранных элементов в демократизации общества и реформировании экономики на основе рыночных принципов, основанных на конкретном пути развития Узбекистана и его роль определяется особым и уникальным характером международных гражданско-правовых отношений в рамках данного предмета. Курс проводится на узбекском, русском и английском языках.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662351290,
                                "updated_at": 1662351290,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4616,
                                "name": "Коллизионные вопросы имущественных и неимущественных прав.",
                                "hours": 4,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "Курс «Международное частное право» рассматривает роль гражданско-правовых отношений с участием иностранных элементов в демократизации общества и реформировании экономики на основе рыночных принципов, основанных на конкретном пути развития Узбекистана и его роль определяется особым и уникальным характером международных гражданско-правовых отношений в рамках данного предмета. Курс проводится на узбекском, русском и английском языках.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662351331,
                                "updated_at": 1662351331,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4617,
                                "name": "Коллизионные вопросы в сделках. Электронные контракты и смарт-контракты.",
                                "hours": 4,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "Курс «Международное частное право» рассматривает роль гражданско-правовых отношений с участием иностранных элементов в демократизации общества и реформировании экономики на основе рыночных принципов, основанных на конкретном пути развития Узбекистана и его роль определяется особым и уникальным характером международных гражданско-правовых отношений в рамках данного предмета. Курс проводится на узбекском, русском и английском языках.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662351361,
                                "updated_at": 1662351361,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4618,
                                "name": "Регулирование международных кредитно-расчетных отношений.",
                                "hours": 4,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "Курс «Международное частное право» рассматривает роль гражданско-правовых отношений с участием иностранных элементов в демократизации общества и реформировании экономики на основе рыночных принципов, основанных на конкретном пути развития Узбекистана и его роль определяется особым и уникальным характером международных гражданско-правовых отношений в рамках данного предмета. Курс проводится на узбекском, русском и английском языках.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662351387,
                                "updated_at": 1662351387,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4619,
                                "name": "Регулирование международных перевозок.",
                                "hours": 2,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "Курс «Международное частное право» рассматривает роль гражданско-правовых отношений с участием иностранных элементов в демократизации общества и реформировании экономики на основе рыночных принципов, основанных на конкретном пути развития Узбекистана и его роль определяется особым и уникальным характером международных гражданско-правовых отношений в рамках данного предмета. Курс проводится на узбекском, русском и английском языках.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662351418,
                                "updated_at": 1662351418,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4620,
                                "name": "Коллизионные вопросы деликтов.",
                                "hours": 2,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "Курс «Международное частное право» рассматривает роль гражданско-правовых отношений с участием иностранных элементов в демократизации общества и реформировании экономики на основе рыночных принципов, основанных на конкретном пути развития Узбекистана и его роль определяется особым и уникальным характером международных гражданско-правовых отношений в рамках данного предмета. Курс проводится на узбекском, русском и английском языках.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662351503,
                                "updated_at": 1662351503,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4621,
                                "name": "Коллизионные вопросы семейных и наследственных отношений",
                                "hours": 4,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "Курс «Международное частное право» рассматривает роль гражданско-правовых отношений с участием иностранных элементов в демократизации общества и реформировании экономики на основе рыночных принципов, основанных на конкретном пути развития Узбекистана и его роль определяется особым и уникальным характером международных гражданско-правовых отношений в рамках данного предмета. Курс проводится на узбекском, русском и английском языках.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662351531,
                                "updated_at": 1662351531,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4622,
                                "name": "Коллизионные вопросы защиты интеллектуальной собственности.",
                                "hours": 2,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "Курс «Международное частное право» рассматривает роль гражданско-правовых отношений с участием иностранных элементов в демократизации общества и реформировании экономики на основе рыночных принципов, основанных на конкретном пути развития Узбекистана и его роль определяется особым и уникальным характером международных гражданско-правовых отношений в рамках данного предмета. Курс проводится на узбекском, русском и английском языках.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662351561,
                                "updated_at": 1662351561,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4623,
                                "name": "Коллизионные вопросы кибер-права.",
                                "hours": 2,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "Курс «Международное частное право» рассматривает роль гражданско-правовых отношений с участием иностранных элементов в демократизации общества и реформировании экономики на основе рыночных принципов, основанных на конкретном пути развития Узбекистана и его роль определяется особым и уникальным характером международных гражданско-правовых отношений в рамках данного предмета. Курс проводится на узбекском, русском и английском языках.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662351603,
                                "updated_at": 1662351603,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4624,
                                "name": "Юрисдикция и разрешение споров в международном частном праве. Международный арбитраж.",
                                "hours": 5,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 3,
                                "description": "Курс «Международное частное право» рассматривает роль гражданско-правовых отношений с участием иностранных элементов в демократизации общества и реформировании экономики на основе рыночных принципов, основанных на конкретном пути развития Узбекистана и его роль определяется особым и уникальным характером международных гражданско-правовых отношений в рамках данного предмета. Курс проводится на узбекском, русском и английском языках.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662351628,
                                "updated_at": 1662351628,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4625,
                                "name": "Халқаро хусусий ҳуқуқ моҳияти, тамойиллари, манбалари ва субъектлари.",
                                "hours": 6,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662352291,
                                "updated_at": 1662352291,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4626,
                                "name": "Ашёвий ва номулкий ҳуқуқларни коллизион масалалари.",
                                "hours": 4,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади. ",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662352394,
                                "updated_at": 1662352394,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4627,
                                "name": "Битимларни коллизион масалалари. Электрон шартномалар ва Smart контрактлар.",
                                "hours": 4,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади. ",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662352420,
                                "updated_at": 1662352420,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4628,
                                "name": "Халқаро кредит ва ҳисоб-китоб муносабатларни тартибга солиниши.",
                                "hours": 4,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади. ",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662352454,
                                "updated_at": 1662352454,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4629,
                                "name": "Халқаро ташишларни тартибга солиниши.",
                                "hours": 2,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади. ",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662352478,
                                "updated_at": 1662352478,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4630,
                                "name": "Деликтнинг коллизион масалалари.",
                                "hours": 2,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662352511,
                                "updated_at": 1662352511,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4631,
                                "name": "Оила ва ворислик муносабатларини коллизион масалалари.",
                                "hours": 4,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади.",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662352538,
                                "updated_at": 1662352538,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4632,
                                "name": "Интеллектуал мулкни ҳимоя қилишининг коллизион масалалари.",
                                "hours": 2,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади. ",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662352560,
                                "updated_at": 1662352560,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4633,
                                "name": "Кибер ҳуқуқни коллизон масалалари.",
                                "hours": 2,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади. ",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662352583,
                                "updated_at": 1662352583,
                                "created_by": 601,
                                "updated_by": 0
                            },
                            {
                                "id": 4634,
                                "name": "Халқаро хусусий ҳуқуқда юрисдикция ва низоларни ҳал этиш. Халқаро арбитраж.",
                                "hours": 5,
                                "subject_id": 209,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "“Халқаро хусусий ҳуқуқ” модулининг тавсифи жамиятни демократлаштириш ва иқтисодиётни бозор тамойиллари асосида ислоҳ қилишдаги аҳамияти чет эл элементи иштирокидаги фуқаролик-ҳуқуқий муносабатларни Ўзбекистоннинг ўзига хос тараққиёт йўлидан келиб чиқиб ўрганади ва унинг ўрни фан предмети доирасидаги халқаро фуқаролик-ҳуқуқий муносабатларнинг алоҳида ва такрорланмас хусусиятга эгалиги билан белгиланади. Модул ўзбек, рус ва инглиз тилларида олиб борилади. ",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1662352604,
                                "updated_at": 1662352604,
                                "created_by": 601,
                                "updated_by": 0
                            }
                        ]
                    },
                    "subjectType": {
                        "id": 6,
                        "name": "Ixtiyoriy",
                        "order": 1,
                        "status": 1,
                        "created_at": 1643784484,
                        "updated_at": 1643784484,
                        "created_by": 2,
                        "updated_by": 0
                    },
                    "selection": null
                },
                {
                    "id": 626,
                    "edu_semestr_id": 331,
                    "subject_id": 309,
                    "subject_type_id": 5,
                    "auditory_time": null,
                    "credit": 6,
                    "all_ball_yuklama": 0,
                    "is_checked": 0,
                    "max_ball": 0,
                    "order": 1,
                    "status": 0,
                    "created_at": 1662134906,
                    "updated_at": 1662711240,
                    "created_by": 7401,
                    "updated_by": 7401,
                    "subject": {
                        "id": 309,
                        "name": "Nodavlat notijorat tashkilotlar huquqi",
                        "kafedra_id": 15,
                        "semestr_id": 7,
                        "parent_id": null,
                        "is_deleted": 0,
                        "order": 1,
                        "status": 1,
                        "created_at": 1661523979,
                        "updated_at": 1661670599,
                        "created_by": 591,
                        "updated_by": 591,
                        "topics": [
                            {
                                "id": 3189,
                                "name": "1-мавзу. ННТ тушунчаси, роли ва таснифи. ННТ ҳуқуқи фанининг предмети",
                                "hours": 2,
                                "subject_id": 309,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605273,
                                "updated_at": 1661605273,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3190,
                                "name": "1-мавзу. ННТ тушунчаси, роли ва таснифи. ННТ ҳуқуқи фанининг предмети",
                                "hours": 2,
                                "subject_id": 309,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605282,
                                "updated_at": 1661605282,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3191,
                                "name": "2-мавзу. ННТнинг ҳуқуқий  асослари",
                                "hours": 2,
                                "subject_id": 309,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605308,
                                "updated_at": 1661605308,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3192,
                                "name": "2-мавзу. ННТнинг ҳуқуқий  асослари",
                                "hours": 4,
                                "subject_id": 309,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605318,
                                "updated_at": 1661605318,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3193,
                                "name": "3-мавзу. ННТни ташкил этиш",
                                "hours": 2,
                                "subject_id": 309,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605340,
                                "updated_at": 1661605340,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3194,
                                "name": "3-мавзу. ННТни ташкил этиш",
                                "hours": 2,
                                "subject_id": 309,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605349,
                                "updated_at": 1661605349,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3195,
                                "name": "4-мавзу. ННТни бошқариш, молиялаштириш ва солиққа тортиш",
                                "hours": 2,
                                "subject_id": 309,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605363,
                                "updated_at": 1661605363,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3196,
                                "name": "4-мавзу. ННТни бошқариш, молиялаштириш ва солиққа тортиш",
                                "hours": 4,
                                "subject_id": 309,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605371,
                                "updated_at": 1661605371,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3197,
                                "name": "5-мавзу. ННТ фаолиятини тўхтатиб туриш ва тугатиш асослари",
                                "hours": 2,
                                "subject_id": 309,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605391,
                                "updated_at": 1661605391,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3198,
                                "name": "5-мавзу. ННТ фаолиятини тўхтатиб туриш ва тугатиш асослари",
                                "hours": 2,
                                "subject_id": 309,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605398,
                                "updated_at": 1661605398,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3199,
                                "name": "6-мавзу. Ижтимоий шерикликнинг ҳуқуқий механизмлари",
                                "hours": 2,
                                "subject_id": 309,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605419,
                                "updated_at": 1661605419,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3200,
                                "name": "6-мавзу. Ижтимоий шерикликнинг ҳуқуқий механизмлари",
                                "hours": 4,
                                "subject_id": 309,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605427,
                                "updated_at": 1661605427,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3201,
                                "name": "7-мавзу. Жамоатчилик назоратини амалга оширишда ННТнинг иштироки",
                                "hours": 2,
                                "subject_id": 309,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605441,
                                "updated_at": 1661605441,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3202,
                                "name": "7-мавзу. Жамоатчилик назоратини амалга оширишда ННТнинг иштироки",
                                "hours": 4,
                                "subject_id": 309,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605451,
                                "updated_at": 1661605451,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3203,
                                "name": "8-мавзу. Жамоат бирлашмалари. Фондлар. Хайрия ташкилотлари",
                                "hours": 2,
                                "subject_id": 309,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605466,
                                "updated_at": 1661605466,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3204,
                                "name": "8-мавзу. Жамоат бирлашмалари. Фондлар. Хайрия ташкилотлари",
                                "hours": 4,
                                "subject_id": 309,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605475,
                                "updated_at": 1661605475,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3205,
                                "name": "9-мавзу. Сиёсий партиялар. Фуқароларнинг ўзини ўзи бошқариш органлари ва диний ташкилотлар",
                                "hours": 2,
                                "subject_id": 309,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605495,
                                "updated_at": 1661605495,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3206,
                                "name": "9-мавзу. Сиёсий партиялар. Фуқароларнинг ўзини ўзи бошқариш органлари ва диний ташкилотлар",
                                "hours": 4,
                                "subject_id": 309,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605504,
                                "updated_at": 1661605504,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3207,
                                "name": "10-мавзу. ННТ фаолиятининг қиёсий-ҳуқуқий таҳлили",
                                "hours": 2,
                                "subject_id": 309,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605519,
                                "updated_at": 1661605519,
                                "created_by": 591,
                                "updated_by": 0
                            },
                            {
                                "id": 3208,
                                "name": "10-мавзу. ННТ фаолиятининг қиёсий-ҳуқуқий таҳлили",
                                "hours": 5,
                                "subject_id": 309,
                                "subject_category_id": 2,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661605526,
                                "updated_at": 1661605526,
                                "created_by": 591,
                                "updated_by": 0
                            }
                        ]
                    },
                    "subjectType": {
                        "id": 5,
                        "name": "Majburiy",
                        "order": 1,
                        "status": 1,
                        "created_at": 1643784471,
                        "updated_at": 1643784471,
                        "created_by": 2,
                        "updated_by": 0
                    },
                    "selection": null
                },
                {
                    "id": 628,
                    "edu_semestr_id": 331,
                    "subject_id": 334,
                    "subject_type_id": 6,
                    "auditory_time": null,
                    "credit": 6,
                    "all_ball_yuklama": 0,
                    "is_checked": 0,
                    "max_ball": 0,
                    "order": 1,
                    "status": 0,
                    "created_at": 1662135101,
                    "updated_at": 1662711488,
                    "created_by": 7401,
                    "updated_by": 7401,
                    "subject": {
                        "id": 334,
                        "name": "Huquqiy loyiha boshqaruvi",
                        "kafedra_id": 3,
                        "semestr_id": 7,
                        "parent_id": null,
                        "is_deleted": 0,
                        "order": 1,
                        "status": 1,
                        "created_at": 1661929538,
                        "updated_at": 1661929538,
                        "created_by": 184,
                        "updated_by": 0,
                        "topics": []
                    },
                    "subjectType": {
                        "id": 6,
                        "name": "Ixtiyoriy",
                        "order": 1,
                        "status": 1,
                        "created_at": 1643784484,
                        "updated_at": 1643784484,
                        "created_by": 2,
                        "updated_by": 0
                    },
                    "selection": null
                },
                {
                    "id": 681,
                    "edu_semestr_id": 331,
                    "subject_id": 356,
                    "subject_type_id": 6,
                    "auditory_time": null,
                    "credit": 6,
                    "all_ball_yuklama": 0,
                    "is_checked": 0,
                    "max_ball": 0,
                    "order": 1,
                    "status": 0,
                    "created_at": 1662699405,
                    "updated_at": 1662711411,
                    "created_by": 7401,
                    "updated_by": 7401,
                    "subject": {
                        "id": 356,
                        "name": "O'z o'zini boshqarish huquqi",
                        "kafedra_id": 15,
                        "semestr_id": 7,
                        "parent_id": null,
                        "is_deleted": 0,
                        "order": 1,
                        "status": 1,
                        "created_at": 1662698242,
                        "updated_at": 1662698242,
                        "created_by": 7401,
                        "updated_by": 0,
                        "topics": []
                    },
                    "subjectType": {
                        "id": 6,
                        "name": "Ixtiyoriy",
                        "order": 1,
                        "status": 1,
                        "created_at": 1643784484,
                        "updated_at": 1643784484,
                        "created_by": 2,
                        "updated_by": 0
                    },
                    "selection": null
                },
                {
                    "id": 682,
                    "edu_semestr_id": 331,
                    "subject_id": 357,
                    "subject_type_id": 6,
                    "auditory_time": null,
                    "credit": 6,
                    "all_ball_yuklama": 0,
                    "is_checked": 0,
                    "max_ball": 0,
                    "order": 1,
                    "status": 0,
                    "created_at": 1662699433,
                    "updated_at": 1662711440,
                    "created_by": 7401,
                    "updated_by": 7401,
                    "subject": {
                        "id": 357,
                        "name": "Yuridik xizmat",
                        "kafedra_id": 6,
                        "semestr_id": 7,
                        "parent_id": null,
                        "is_deleted": 0,
                        "order": 1,
                        "status": 1,
                        "created_at": 1662698284,
                        "updated_at": 1662871153,
                        "created_by": 7401,
                        "updated_by": 599,
                        "topics": []
                    },
                    "subjectType": {
                        "id": 6,
                        "name": "Ixtiyoriy",
                        "order": 1,
                        "status": 1,
                        "created_at": 1643784484,
                        "updated_at": 1643784484,
                        "created_by": 2,
                        "updated_by": 0
                    },
                    "selection": {
                        "id": 3588,
                        "edu_semestr_subject_id": 682,
                        "student_id": 5229,
                        "edu_semester_id": 331,
                        "subject_id": 357,
                        "faculty_id": 2,
                        "edu_plan_id": 56,
                        "type": null,
                        "user_id": 6976,
                        "description": null,
                        "status": 2,
                        "is_deleted": 0,
                        "created_at": 1663425573,
                        "updated_at": 1663425573,
                        "created_by": 6976
                    }
                },
                {
                    "id": 703,
                    "edu_semestr_id": 331,
                    "subject_id": 300,
                    "subject_type_id": 5,
                    "auditory_time": null,
                    "credit": 6,
                    "all_ball_yuklama": 0,
                    "is_checked": 0,
                    "max_ball": 0,
                    "order": 1,
                    "status": 0,
                    "created_at": 1663064064,
                    "updated_at": 1663064086,
                    "created_by": 7401,
                    "updated_by": 7401,
                    "subject": {
                        "id": 300,
                        "name": "Yuridik texnika",
                        "kafedra_id": 1,
                        "semestr_id": 1,
                        "parent_id": null,
                        "is_deleted": 0,
                        "order": 1,
                        "status": 1,
                        "created_at": 1661259600,
                        "updated_at": 1661259600,
                        "created_by": 596,
                        "updated_by": 0,
                        "topics": [
                            {
                                "id": 2316,
                                "name": "Юридическая техника и виды юридических документов",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661318658,
                                "updated_at": 1661318658,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 2317,
                                "name": "Общие и лингвистические правилы юридической техники ",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661318696,
                                "updated_at": 1661318696,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 2318,
                                "name": "Юридическая техника нормативно-правовых актов ",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661318744,
                                "updated_at": 1661318744,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 2319,
                                "name": "Экспертиза как важный институт юридической техники ",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661318777,
                                "updated_at": 1661318777,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 2320,
                                "name": "Информационные технологии в работе  с юридическими документами ",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661318823,
                                "updated_at": 1661318823,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 2321,
                                "name": "Техника особых юридических документов ",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661318861,
                                "updated_at": 1661318861,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 2322,
                                "name": "Юридическая техника правоприминительного документа ",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661318889,
                                "updated_at": 1661318889,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 2323,
                                "name": "Юридическая техника судебных актов ",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661318942,
                                "updated_at": 1661318942,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 2324,
                                "name": "Пути систематизации коллизиев в праве и устранения пробелов в нормативно-правовых актах",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661318989,
                                "updated_at": 1661318989,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 2325,
                                "name": "Юридическая техника по толкованию права ",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 3,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661319018,
                                "updated_at": 1661319018,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 4299,
                                "name": "Юридик техника ва юридик ҳужжат турлари",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661958399,
                                "updated_at": 1661958399,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 4301,
                                "name": "Юридик техниканинг умумий ва лингвистик қоидалари",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661958496,
                                "updated_at": 1661958496,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 4303,
                                "name": "Норматив-ҳуқуқий ҳужжатларнинг юридик техникаси",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661958535,
                                "updated_at": 1661958535,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 4304,
                                "name": "Экспертиза юридик техниканинг муҳим институти",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661958580,
                                "updated_at": 1661958580,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 4305,
                                "name": "Юридик ҳужжатлар билан ишлашда ахборот технологиялари",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661958617,
                                "updated_at": 1661958617,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 4306,
                                "name": "Алоҳида юридик ҳужжатларнинг техникаси",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661958650,
                                "updated_at": 1661958650,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 4307,
                                "name": "Ҳуқуқни қўллаш ҳужжатининг юридик техникаси",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661958693,
                                "updated_at": 1661958693,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 4308,
                                "name": "Суд ҳужжатларининг юридик техникаси",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661958726,
                                "updated_at": 1661958726,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 4309,
                                "name": "Норматив-ҳуқуқий ҳужжатларни тизимлаштириш, ҳуқуқдаги коллизия ва бўшлиқларни бартараф этиш йўллари",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661958765,
                                "updated_at": 1661958765,
                                "created_by": 596,
                                "updated_by": 0
                            },
                            {
                                "id": 4310,
                                "name": "Ҳуқуқни шарҳлаш ҳужжатларининг юридик техникаси",
                                "hours": 2,
                                "subject_id": 300,
                                "subject_category_id": 1,
                                "lang_id": 1,
                                "description": "undefined",
                                "teacher_access_id": null,
                                "order": 1,
                                "status": 1,
                                "created_at": 1661958798,
                                "updated_at": 1661958798,
                                "created_by": 596,
                                "updated_by": 0
                            }
                        ]
                    },
                    "subjectType": {
                        "id": 5,
                        "name": "Majburiy",
                        "order": 1,
                        "status": 1,
                        "created_at": 1643784471,
                        "updated_at": 1643784471,
                        "created_by": 2,
                        "updated_by": 0
                    },
                    "selection": null
                }
            ],
            "_links": {
                "self": {
                    "href": "https://api-digital.tsul.uz/api/web/uz/edu-semestr-subjects?expand=subject%2Csubject.topics%2CsubjectType%2Cselection%2Csillabus&filter=%27%7B%22edu_semestr_id%22%3A331%7D%27&per-page=0&page=1"
                },
                "first": {
                    "href": "https://api-digital.tsul.uz/api/web/uz/edu-semestr-subjects?expand=subject%2Csubject.topics%2CsubjectType%2Cselection%2Csillabus&filter=%27%7B%22edu_semestr_id%22%3A331%7D%27&per-page=0&page=1"
                },
                "last": {
                    "href": "https://api-digital.tsul.uz/api/web/uz/edu-semestr-subjects?expand=subject%2Csubject.topics%2CsubjectType%2Cselection%2Csillabus&filter=%27%7B%22edu_semestr_id%22%3A331%7D%27&per-page=0&page=1"
                }
            },
            "_meta": {
                "totalCount": 7,
                "pageCount": 1,
                "currentPage": 1,
                "perPage": 0
            }
          }*/
          setSubjects(res?.items?.filter((e: any) => e?.subjectType?.id === 6))

          res.items.forEach((e: any) => {
            if (e?.selection) {
              setIsSave(true)
              setSelectedSubjectId(e?.id);
            }
          })
          setLoading(false);
        } catch (error: any) { }
      }
    )()
  }, [])

  const viewSubjectTopic = (id: number) => {
    let topics: TypeTopics = []
    const stopics = subjects?.find((e: any) => e?.id === id)?.subject?.topics;

    stopics?.forEach((e: any) => {
      topics.push({ id: e?.id, name: e?.name, description: e?.description })
    })

    localStorage.setItem('topics', JSON.stringify(topics))
  }

  const onSubmit = async () => {
    if (selectedSubjectId) {
      try {
        const data = new FormData();
        data.append("edu_semestr_subject_id", String(selectedSubjectId))
        const response = await instance({ url: "/student-subject-selections", method: "POST", data })

        if (response.data.status === 1) {
          message.success(response.data?.message)
        }
      } catch (error) { }
      setIsSave(true)
    } else {
      message.warning("Iltimos fanni tanlang")
    }
  }

  return (
    <Card bordered={false}>
        <SelectSubjectWrapper theme={theme}>
          <Title color={theme.header_text} >Fan tanlash</Title>
          <Alert type="warning" description="Bu fanlar tanlovi fan hamda bir marotaba tanlash imkoni mavjud! Eng ko'p ovoz to'plagan fan(lar) bo'yicha 2022-2023 o'quv yili tegishli yo'nalishlar uchun o'qitilishi belgilanadi." />
          <Spin spinning={loading} >
            {
                subjects?.length ? <>
                <div className="mt-3">
                    {
                    subjects?.map((element: any, i: number) => {
                        if (element.subject?.status === 0) return;
                        return (
                        <Tooltip key={i} title={selectedSubjectId === element?.id && 'Tanlangan'}>
                            <div className="subject-box" onClick={() => !isSave && setSelectedSubjectId(element?.id)} style={{ background: selectedSubjectId === element?.id ? "#c5fc8e" : "" }} >
                            <div style={{ fontSize: 17, fontWeight: 500 }}>{element?.subject?.name}</div>
                            <NavLink to={{ pathname: `/subject_topic/${element?.subject?.name}` }} onClick={() => viewSubjectTopic(element?.id)} >Fan mavzulari</NavLink>
                            {/* <Button onClick={() => viewSubjectTopic(element?.id)} >Fan mavzulari</Button> */}
                            </div>
                        </Tooltip>
                        )
                    })
                    }
                </div>
                <div className="d-f justify-content-end mt-3">
                    <Button size="large" type="primary" onClick={onSubmit} disabled={isSave} > Tanlovni saqlash </Button>
                </div>
                </> : <EmptyData data={subjects} loading={loading} description={"Sizda tanlov fanlar yo'q"} />
            }
          </Spin>
        </SelectSubjectWrapper>
    </Card>
  )
}

export default SubjectSelection;

export const SelectSubjectWrapper = styled.div<{ theme: any }>`
  .header-subject {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${(props) => props.theme.active_element};
    color: ${(props) => props.theme.header_text};
    font-weight: 500;
    height: 2.5rem;
    padding: 0.5rem 1rem;
    border-radius: .5rem .5rem .25rem .25rem;
  }
  .subject-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.5rem;
    padding: 0.5rem 1rem;
    background-color: ${(props) => props.theme.element};
    color: ${(props) => props.theme.text};
    width: 100%;
    min-height: 3.2rem;
    border-radius: 0.3rem;
    cursor: pointer;
    &:hover{
        background-color: ${(props) => props.theme.active_element};
    }
  }
`;